/* import __COLOCATED_TEMPLATE__ from './application-parameters.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();